import type { BaseEvent } from '@shared/types'

/** Тип overlay-события плагина Custom Effects (совпадает с backend interactionKey). */
export const CUSTOM_EFFECTS_TYPE = 'custom_effects' as const

/**
 * Payload события `custom_effects` (единый источник правды — part2-report §6).
 * mediaUrl — presigned GET с коротким TTL, приходит ТОЛЬКО в момент триггера.
 */
export interface CustomEffectsPayload {
  // Индекс-сигнатура: CustomEffectsEvent должен быть присваиваем DynamicEvent
  // (payload: Record<string, unknown>) — иначе EffectPlugin<T extends OverlayEvent>
  // не примет тип. Известные поля ниже остаются строго типизированными.
  [key: string]: unknown
  nickname?: string
  effectAssetId: string
  effectName: string
  kind: 'lottie' | 'image' | 'video'
  mediaUrl: string
  thumbnailUrl?: string
  /** video/lottie — играют по своей длительности; используется как fallback-таймер. */
  durationMs?: number
  /** Только для kind='video'. Для lottie/image — undefined. */
  hasAudio?: boolean
  /** Для kind='image' — сколько держать картинку на экране, сек. */
  displayDurationSecForImages: number
  // zone опционален: старые/частичные payload с бэкенда могут не содержать это поле —
  // в этом случае resolveEventZone откатывается на fullscreen.
  overlayConfig: { zone?: string }
}

export interface CustomEffectsEvent extends BaseEvent {
  type: typeof CUSTOM_EFFECTS_TYPE
  payload: CustomEffectsPayload
}
